import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

const DeviceImage = ({
  loading,
  convoySrc,
  convoyDesc,
  genericSrc,
  genericDesc,
  device: {
    image: {
      webImageLarge: ssmSrc,
    } = {},
    description: ssmDesc,
  },
}) => {
  const [srcs, setSrcs] = useState([]);
  const imageLoadFailed = useCallback(() => {
    setSrcs(srcs.slice(1));
  }, [srcs]);
  useEffect(() => {
    if (!loading) {
      setSrcs([ssmSrc, convoySrc, genericSrc].filter(a => a));
    }
  }, [loading, ssmSrc, convoySrc, genericSrc]);
  if (!srcs.length) return null;
  return (
    <img
      src={srcs[0]}
      alt={ssmDesc || convoyDesc || genericDesc}
      onError={imageLoadFailed}
    />
  );
};

const mapStateToProps = (
  {
    account: {
      loading,
      devices: {
        bySerial = {},
      } = {},
    } = {},
  },
  {
    device: {
      serialNumber: sn,
      lob,
    } = {},
  },
) => () => ({
  loading,
  convoySrc: bySerial[sn]?.images.webImageLarge,
  convoyDesc: bySerial[sn]?.friendlyName,
  genericSrc: lob === 'video'
    ? 'https://static.cimcontent.net/common-web-assets/devices/generic-stb.svg'
    : 'https://static.cimcontent.net/common-web-assets/devices/generic-modem.svg',
  genericDesc: lob === 'video' ? 'stb' : 'modem',
});

export default connect(mapStateToProps)(DeviceImage);
